const isVersionNumber = {
    name: "is-version-number",
    validate: (v) => {
        const arr = v.toString().split(".");
        return arr.length <= 2 && arr[1] ? arr[1].length <= 5 : true;
    },
};
exports.isVersionNumber = isVersionNumber;
